import * as angular from 'angular';

"use strict";

angular.module('StandardsModule', [])

export default 'StandardsModule';